import React from 'react';

import Guarantees from '../guarantees';
import GuaranteePoints from '../guarantees/components/guaranteePoints/GuaranteePoints';
import PaymentOptions from '../guarantees/components/paymentOptions/PaymentOptions';
import BuyerPoints from './components/buyerPoints/BuyerPoints';

interface IGuaranteesForBuyerProps {

}

const GuaranteesForBuyer = (props: IGuaranteesForBuyerProps) => (
  <Guarantees
    guranteePoints={<GuaranteePoints/>}
    paymentOptions={<PaymentOptions/>}
    howItWorksPoints={<BuyerPoints/>}
  />
);

GuaranteesForBuyer.defaultProps = {};

export default React.memo(GuaranteesForBuyer);
